import { render, staticRenderFns } from "./LinkedBoxes.vue?vue&type=template&id=0367ca37&scoped=true&lang=pug&"
import script from "./LinkedBoxes.vue?vue&type=script&lang=js&"
export * from "./LinkedBoxes.vue?vue&type=script&lang=js&"
import style0 from "./LinkedBoxes.vue?vue&type=style&index=0&id=0367ca37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0367ca37",
  null
  
)

export default component.exports